import { createSlice } from "@reduxjs/toolkit";

import { INITIAL_FEED_NODE_ID } from "@features/SystemDesignNew/SystemDesign.constants";

export const createFeedNodeState = () => ({
  activeStreamIdx: 0,
  isFeedTempChanged: false,
  isFeedWaterCalculating: false,
  feedStreams: [],
  blendedFeedWater: {},
  deletedStreams: [],
  validationErrors: { isResetErrors: false },
  sumOfTotalIons: 0,
  isCellExceeding: false,
});

const createInitialState = () => ({
  /* Below Flag should Ideally be per feed node, to change when implementing multi feed feature  */
  isFeedDataChanged: false,
  feedDataById: {
    [INITIAL_FEED_NODE_ID]: createFeedNodeState(),
  },
  treatmentFeedDataById: {
    // [nodeId]: { waterTypeId: "1", waterSubTypeId: "1" },
  },
  reCalcFeedSolver: false,
});

const initialState = createInitialState();

export const FeedSetupSlice = createSlice({
  name: "FeedSetup",
  initialState,
  reducers: {
    updateActiveStreamIdxById: (state, action) => {
      const { feedNodeId, activeStreamIdx = 0 } = action.payload;
      state.feedDataById[feedNodeId].activeStreamIdx = activeStreamIdx;
    },
    updateFeedSetupById: (state, action) => {
      const payload = action.payload;
      const { feedNodeId } = payload;

      state.feedDataById[feedNodeId] = {
        ...state.feedDataById[feedNodeId],
        ...payload,
      };
    },
    updateFeedValidationErrorById: (state, action) => {
      const { feedNodeId, validationErrors } = action.payload;
      state.feedDataById[feedNodeId].validationErrors = {
        ...state.feedDataById[feedNodeId].validationErrors,
        ...validationErrors,
      };
    },
    setTreatmentFeedDataById: (state, action) => {
      state.treatmentFeedDataById = action.payload;
    },
    updateFeedSetup: (state, action) => {
      state = { ...state, ...action.payload };
      return state;
    },

    setIsFeedDataChanged: (state, action) => {
      state.isFeedDataChanged = action.payload;
    },
    setReCalcFeedSolver: (state, action) => {
      state.reCalcFeedSolver = action.payload;
    },
    resetFeedSetup: () => initialState,
  },
});

export const {
  updateFeedSetupById,
  updateFeedValidationErrorById,
  updateActiveStreamIdxById,
  updateFeedSetup,
  setTreatmentFeedDataById,
  setIsFeedDataChanged,
  setReCalcFeedSolver,
  resetFeedSetup,
} = FeedSetupSlice.actions;

export default FeedSetupSlice.reducer;
